import styled from 'styled-components';

export const CustomLayoutWrapper = styled.div`
  background-color: var(--bg-content);
  border: 1px solid var(--border-color-light);
  // margin-top: 20px;
  .ant-tabs-nav {
    margin-bottom: 0px;
    &:before {
      border-bottom: none !important;
    }
  }
  padding: 10px;
  .btn-overlay {
    background-color: var(--light-primary);
    border-color: var(--primary);
    color: var(--primary);
  }
  .ant-tabs-tab-btn {
    opacity: 0.4;
    color: var(--text-title-gray);
  }
  .ant-tabs-tab-active {
    .ant-tabs-tab-btn {
      opacity: 1;
    }
  }
`;
